/** Platform success fee disclosure — shown on upgrade / payment pages */

export const SUCCESS_FEE_OPTIONS = [
  {
    id: 'fundraising',
    name: 'Fundraising',
    percent: 2,
    basis: 'total LP committed capital',
    basisShort: 'LP Committed Capital',
    condition: 'where the LP was introduced or connected through the Platform',
  },
  {
    id: 'asset_sale',
    name: 'Asset Sale',
    percent: 3,
    basis: 'total closed deal value',
    basisShort: 'Closed Deal Value',
    condition: 'where the counterparty was introduced or connected through the Platform',
  },
]

export function successFeeSummaryLines(options = SUCCESS_FEE_OPTIONS) {
  return options.map((fee) => ({
    label: `Success Fee — ${fee.name}`,
    value: `${fee.percent}% × ${fee.basisShort}`,
  }))
}
